export class AzureResourceGroup {
    'name';
    'location';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureResourceGroup.attributeTypeMap;
    }
    constructor() {
    }
}
